const getPieveSessionCompanyId = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  let value = null;

  try {
    value = window.sessionStorage.getItem('sessionCompanyId');
  } catch {
    return null;
  }

  const normalized = String(value || '').trim();
  return normalized || null;
};

export default getPieveSessionCompanyId;
